import './Background.css';
import React, {useEffect, useRef, useState} from 'react';

const BackgroundLayer = () => {
    const containerRef = useRef(null);
    const lightRefs = useRef([]);
    const initialPositions = useRef([]);
    const [lightWidth, setLightWidth] = useState(0);



    useEffect(() => {
        if (containerRef.current) {
            setLightWidth(0.1 * window.innerWidth);
        }
    }, []);

    // Generate initial random positions
    if (initialPositions.current.length === 0) {
        for (let i = 0; i < 3; i++) {
            const maxX = window.innerWidth - (window.innerWidth / 8); // Adjust if light width changes
            const maxY = window.innerHeight - (window.innerHeight / 8); // Adjust if light height changes

            const randomX = Math.floor(Math.random() * maxX);
            const randomY = Math.floor(Math.random() * maxY);

            initialPositions.current.push({ x: randomX, y: randomY });
        }
    }

    useEffect(() => {
        // Remove 'no-transition' class to enable transitions
        lightRefs.current.forEach((light) => {
            light.classList.remove('no-transition');
        });

        // Function to move a light to a random position
        function moveLightRandomly(light) {
            const container = containerRef.current;
            const containerWidth = container.offsetWidth;
            const containerHeight = container.offsetHeight;

            const maxX = containerWidth - (lightWidth); // Adjust if light width changes
            const maxY = containerHeight - (lightWidth); // Adjust if light height changes

            const randomX = Math.floor(Math.random() * maxX);
            const randomY = Math.floor(Math.random() * maxY);

            light.style.transform = `translate(${randomX}px, ${randomY}px)`;
        }

        // Function to continuously move lights
        function animateLights() {
            lightRefs.current.forEach((light) => {
                moveLightRandomly(light);
            });

            const randomDelay = 4000; // Between 2s and 4s
            timeoutId = setTimeout(animateLights, randomDelay);
        }

        let timeoutId;
        animateLights();

        // Cleanup function to clear the timeout when the component unmounts
        return () => {
            clearTimeout(timeoutId);
        };
    }, []);



    return (
        <div className="background-layer" ref={containerRef}>
            {['light-1', 'light-2', 'light-3'].map((lightClass, index) => (
                <div
                    key={index}
                    className={`light ${lightClass} no-transition`}
                    ref={(el) => (lightRefs.current[index] = el)}
                    style={{
                        transform: `translate(${initialPositions.current[index].x}px, ${initialPositions.current[index].y}px)`,
                        width: '10%',
                        height: 0,
                        paddingBottom: '10%'
                    }}
                ></div>
            ))}
        </div>
    );
};

export default BackgroundLayer;
